import { useQuery } from '@tanstack/react-query';

import { isPrometheusConfigured } from '@/shared/config/prometheus-config';
import { useQueryWithBoundary } from '@/shared/lib/query';
import { monitoringKeys } from '@/shared/lib/query/queryKeys';

import { GPU_METRICS_CONFIG } from '@/features/monitoring/api/constants';
import { getGpuMemoryUsed, getGpuMemoryUsedSummary } from '@/features/monitoring/api/prometheusApi';

/**
 * 클러스터 전체 GPU 메모리 사용량 조회 Hook
 */
export const useGpuMemoryUsed = () => {
  const enabled = isPrometheusConfigured();
  const queryKey = monitoringKeys.gpuMetric('gpu-memory-used', 'cluster');

  const summaryQuery = useQueryWithBoundary({
    queryKey,
    queryFn: getGpuMemoryUsedSummary,
    enabled,
    staleTime: GPU_METRICS_CONFIG.STALE_TIME,
    refetchInterval: GPU_METRICS_CONFIG.REFETCH_INTERVAL,
    retry: GPU_METRICS_CONFIG.RETRY_COUNT,
  });

  const detailQuery = useQuery({
    queryKey: [...queryKey, 'detail'],
    queryFn: getGpuMemoryUsed,
    enabled,
    staleTime: GPU_METRICS_CONFIG.STALE_TIME,
    refetchInterval: GPU_METRICS_CONFIG.REFETCH_INTERVAL,
    retry: false,
  });

  return {
    ...summaryQuery,
    data: detailQuery.data ?? summaryQuery.data,
    isFetching: summaryQuery.isFetching || detailQuery.isFetching,
    isLoading: summaryQuery.isLoading,
  };
};
